
import React, { useState } from 'react';
import '../styles/KnightAssistant.css';
import { FaShieldAlt } from 'react-icons/fa';
import ReactMarkdown from 'react-markdown';

function KnightAssistant() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [response, setResponse] = useState('');
  const [loading, setLoading] = useState(false);

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const res = await fetch('/api/ask', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message })
    });

    const data = await res.json();
    setResponse(data.reply);
    setMessage(''); // <-- Clears the input after success
  } catch (err) {
    setResponse('Something went wrong. Try again!');
    console.error(err);
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="knight-assistant">
      <div className="floating-icon" onClick={() => setOpen(!open)} title="Summon the Knight">
        <FaShieldAlt />
      </div>

      {open && (
        <div className="assistant-popup">
          <form onSubmit={handleSubmit}>
            <h4>Network Squire</h4>
            <input
              type="text"
              placeholder="Ask me anything..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <button type="submit" disabled={loading}>
              {loading ? 'Summoning...' : 'Ask'}
            </button>
          </form>
          {response && (
            <div className="assistant-response">
              <ReactMarkdown>{response}</ReactMarkdown>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default KnightAssistant;
